import { IMaskInput } from 'react-imask';
import styled, { css } from 'styled-components';

import {
  pressableControlLifecycleStyles,
  structuralControlResetStyles,
  textInputLifecycleStyles,
} from './reset.styles';
import { inheritedTypographyStyles } from './typography.styles';

export const buttonResetStyles = css`
  ${pressableControlLifecycleStyles};
`;

export const inputResetStyles = css`
  ${textInputLifecycleStyles};
`;

export const BaseButton = styled.button`
  ${inheritedTypographyStyles};
  ${buttonResetStyles};
`;

export const BaseInput = styled.input`
  ${inheritedTypographyStyles};
  ${structuralControlResetStyles};
  ${inputResetStyles};
`;

export const BaseMaskedInput = styled(IMaskInput)`
  ${inheritedTypographyStyles};
  ${inputResetStyles};
`;

export const BaseTextArea = styled.textarea`
  ${inheritedTypographyStyles};
  ${structuralControlResetStyles};
  ${inputResetStyles};
`;
